export default __webpack_public_path__ + "static/icon-51e201d53bf163dcd21aa44881c6294e.png";